module.exports = __webpack_public_path__ + "static/media/cod_burger2-dt-en.e10fdacb.jpg";